export default {
  SHARES_PAGE_GROUP: 'Shares',
  SHARES_PAGE_GROUP_SINGULAR: 'Share',
  SHARES_PAGE_GROUP_PLURAL: 'Shares',
  SHARES_PAGE_SUB_TITLE: 'Shares you hold today across all plans',
  SHARES_TOTAL_VALUE: 'TOTAL VALUE',
  SHARES_TOTAL: 'TOTAL SHARES',
  SHARES_PAGE_TITLE: 'Current Shareholdings',
  SHARES_PROVIDER_CAPTION: 'To view more details about the plans, please visit %PROVIDER%',
  PROFILE_VESTED_SHARES: 'VESTED',
  PROFILE_UNVESTED_SHARES: 'UNVESTED',
  SHARES_PLAN_TOTAL: 'Plan total',
  GRANTED_SHARES_TITLE: 'Granted shares in',
  GRANTED_SHARES_CAPTION:'The values of the shares reflect the Stock Exchange end of day prices. The value of the granted shares reflects the value of the shares at granted date.',
  GRANTED_SHARES_TOTAL: 'Total',
  SHARES_SUMMARY_CAPTION: 'The amounts displayed are rounded down.',
  SHARES_PRICE_LABEL_TITLE: 'Price last updated',
};
